export default "__VITE_ASSET__Bsyjoi3l__"